import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import LanguageTabsForms from '../Tabs/LanguageTabsForms';
import TagsInput from '../Views/StructureComponents/TagsInput';

const ActiveTag = ({ title, callback }) => (
  <span className="cursor-pointer bg-gray200 py-1 px-2 mr-2 mb-2 font-americaMonoBold text-xs rounded-lg flex items-center uppercase text-white">
    <div className="flex justify-center" onClick={() => (callback ? callback(title) : null)}>
      {callback ? 'X' : ''}
      {' '}
      {title}
    </div>
  </span>
);
const width = 'px-8';

const GalleryForm = ({
  galleryData: {
    title, description, name, tags, showFilter, showSearch, filterText, hideDownloadButton,
  }, inputHandler, inputObjectHandler, sendGallery, toggleTag,
}) => {
  const [hFilter, setHasFilter] = useState(showFilter || false);

  const handleTags = (tag) => {
    toggleTag(tag);
  };

  const handleSearch = () => {
    inputHandler({ target: { name: 'showSearch', value: !showSearch } });
  };

  const handleButton = () => {
    inputHandler({ target: { name: 'hideDownloadButton', value: !hideDownloadButton } });
  };

  return (
    <div className="bg-grey-avatar w-full rounded">
      <div className="text-xs font-americaMonoRegular uppercase text-black flex flex-col p-8 pb-2">
        Name
        <input onChange={inputHandler} className="font-americaMonoRegular rounded-full py-2 px-4 outline-none mt-2 mb-4 text-sm font-americaMonoRegular " name="name" type="text" value={name} />
      </div>
      <LanguageTabsForms width={width} activeTabStyle="tab" tabStyle="active">
        {(activeLanguage, languages) => languages.map(lang => (
          <div key={lang}>
            <div className={`w-full ${activeLanguage === lang ? 'block' : 'hidden'} p-7 pb-0 rounded-b-lg bg-greyFilter pb-4 mb-4`}>
              <div className="text-xs font-americaMonoRegular uppercase text-black flex flex-col">
                Gallery Title
                <input onChange={inputObjectHandler} className="font-americaMonoRegular rounded-full py-2 px-4 outline-none mt-2 mb-4 text-sm font-americaMonoRegular " name="title" type="text" lang={lang} value={title[lang]} />
              </div>
              <div className="text-xs font-americaMonoRegular uppercase text-black flex flex-col">
                Description
                <input onChange={inputObjectHandler} className="font-americaMonoRegular rounded-lg py-1 px-4 outline-none mt-2 mb-4 h-170px" name="description" type="text" lang={lang} value={description[lang]} />
              </div>

              {/* <input className="font-americaMonoRegular p-2 bg-white outline-none w-full" name="description" value={objState.description.lang} lang={lang} type="text" /> */}
            </div>

            {/* <input className="font-americaMonoRegular p-2 bg-white outline-none w-full" name="description" value={objState.description.lang} lang={lang} type="text" /> */}
          </div>
        ))
        }
      </LanguageTabsForms>
      <div className="w-full mt-4 px-8 h-24">
        <TagsInput toggleTag={handleTags} color="black" />
        <div className="h-16 mt-4">
          <div className="flex flex-wrap">{tags && tags.map(tag => <ActiveTag key={tag} callback={handleTags} title={tag} />)}</div>
        </div>
      </div>
      <div className="font-americaMonoRegular text-xs uppercase text-black px-8">
        <label htmlFor="showFilter">
          Filters
          <input className="ml-2" id="showFilter" name="showFilter" checked={hFilter} onChange={() => { setHasFilter(!hFilter); inputHandler({ target: { name: 'showFilter', value: !hFilter } }); }} type="checkbox" />
        </label>
        <label htmlFor="showSearch" className="ml-2">
          Search bar
          <input className="ml-2" id="showSearch" name="showSearch" checked={showSearch} onChange={handleSearch} type="checkbox" />
        </label>
        <label htmlFor="hideDownloadButton" className="ml-2">
          Hide Download Button
          <input className="ml-2" id="hideDownloadButton" name="hideDownloadButton" checked={hideDownloadButton} onChange={handleButton} type="checkbox" />
        </label>
      </div>
      {hFilter && (
        <LanguageTabsForms width={width} activeTabStyle="tab" tabStyle="active">
          {(activeLanguage, languages) => languages.map(lang => (
            <div key={lang} className="mt-2">
              <div className={`w-full ${activeLanguage === lang ? 'block' : 'hidden'} p-7 pb-0 rounded-b-lg bg-greyFilter pb-4 mb-4`}>
                <div className="text-xs font-americaMonoRegular uppercase text-black flex flex-col">
                  Filter Title
                  <input onChange={inputObjectHandler} className="font-americaMonoRegular rounded-full py-2 px-4 outline-none mt-2 mb-4 text-sm font-americaMonoRegular" name="filterText" type="text" lang={lang} value={(filterText && filterText[lang]) || ''} />
                </div>
              </div>
            </div>
          ))
        }
        </LanguageTabsForms>
      )}
      <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full bg-black text-white uppercase ml-7 mt-2 mb-7" onClick={sendGallery} type="button">
        Save Gallery
      </button>
    </div>
  );
};

GalleryForm.propTypes = {
  galleryData: PropTypes.shape().isRequired,
  inputHandler: PropTypes.func.isRequired,
  inputObjectHandler: PropTypes.func.isRequired,
  sendGallery: PropTypes.func.isRequired,
  toggleTag: PropTypes.func.isRequired,
};

export default GalleryForm;
